var initUglyCakesBox = function initUglyCakesBox() {
  var cakes = Array.from(document.querySelectorAll('.bundled-product'));
  cakes.forEach(function (cake, index) {
    var cakeNumber = index + 1;

    // Función para actualizar el input oculto
    var updateHiddenInput = function updateHiddenInput() {
      var selections = [];

      // Cover
      var coverSelect = cake.querySelector("#coverUgly".concat(cakeNumber));
      if (coverSelect) {
        var _coverSelect$options$;
        var selectedCover = ((_coverSelect$options$ = coverSelect.options[coverSelect.selectedIndex]) === null || _coverSelect$options$ === void 0 ? void 0 : _coverSelect$options$.value) || 'none';
        selections.push("cover: ".concat(selectedCover));
      }

      // Filling
      var fillingSelect = cake.querySelector("#fillingUgly".concat(cakeNumber));
      if (fillingSelect) {
        var _fillingSelect$option;
        var selectedFilling = ((_fillingSelect$option = fillingSelect.options[fillingSelect.selectedIndex]) === null || _fillingSelect$option === void 0 ? void 0 : _fillingSelect$option.value) || 'none';
        selections.push("filling: ".concat(selectedFilling));
      }

      // Flavor
      var flavorSelect = cake.querySelector("#flavorUgly".concat(cakeNumber));
      if (flavorSelect) {
        var _flavorSelect$options;
        var selectedFlavor = ((_flavorSelect$options = flavorSelect.options[flavorSelect.selectedIndex]) === null || _flavorSelect$options === void 0 ? void 0 : _flavorSelect$options.value) || 'none';
        selections.push("flavor: ".concat(selectedFlavor));
      }

      // Color
      var colorInput = cake.querySelector("#color-cake".concat(cakeNumber));
      if (colorInput) {
        var selectedColor = colorInput.value || 'none';
        selections.push("color: ".concat(selectedColor));
      }

      // Combine selections into a string
      var cakeSelections = selections.join(', ');

      // Update the corresponding hidden input
      var hiddenInput = document.querySelector("input[name=\"properties[Cake ".concat(cakeNumber, "]\"]"));
      if (hiddenInput) {
        hiddenInput.value = cakeSelections;
      }
    };

    // Add event listeners for each field
    var coverSelect = cake.querySelector("#coverUgly".concat(cakeNumber));
    if (coverSelect) {
      coverSelect.addEventListener('change', updateHiddenInput);
    }
    var fillingSelect = cake.querySelector("#fillingUgly".concat(cakeNumber));
    if (fillingSelect) {
      fillingSelect.addEventListener('change', updateHiddenInput);
    }
    var flavorSelect = cake.querySelector("#flavorUgly".concat(cakeNumber));
    if (flavorSelect) {
      flavorSelect.addEventListener('change', updateHiddenInput);
    }
    var colorInput = cake.querySelector("#color-cake".concat(cakeNumber));
    if (colorInput) {
      colorInput.addEventListener('input', updateHiddenInput); // 'input' for real-time updates
    }

    // Initialize the input with the current values
    updateHiddenInput();
  });
};
export default initUglyCakesBox;